export type THeaders = {
  "Content-Type"?: string;
  Authorization?: string;
  "Ocp-Apim-Subscription-Key"?: string;
};

type THTTPError = {
  status: number;
  statusText: string;
};

export const postFetch = async (url: string, body: any, headers: THeaders = { "Content-Type": "application/json" }) => {
  const response = fetch(url, {
    method: "POST",
    body: body,
    headers: headers,
  });

  return response
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      }

      const error: THTTPError = {
        status: res.status,
        statusText: res.statusText,
      };

      throw error;
    })
    .catch((err) => {
      console.error(err);
    });
};
